import './NavItem.css';
export var button = '_13xycoq2-2-0-1';
export var isDisabled = '_13xycoq1-2-0-1';
export var isSelected = '_13xycoq0-2-0-1';